// Module
var code = "<div class=\"saving-indicator\" layout layout-align=\"center center\"> <div ng-if=\"ctrl.saveState\" class=\"saving-message enter-fade\" layout=\"row\" layout-align=\"center center\" ng-class=\"{'ck-warn': ctrl.saveState === ctrl.SAVE_ERROR || ctrl.saveState === ctrl.SAVE_ERROR_STUDENT_DUPLICATE}\"> {{ctrl.saveMessage}} </div> </div> ";
// Exports
module.exports = code;